import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface RecentCall {
  phoneNumber: string;
  lastCall: string;
  isActive: boolean;
  callType: string;
  note: string;
  callId: string;
}

export interface Communication {
  id: number;
  order_number?: number;
  root_order_id?: number;
  order_id?: number;
  customer_id?: number;
  customer_branch_id?: number;
  user_id?: number;
  person_id?: number;
  com_type: string;
  io: string;
  status_id?: number;
  token: string;
  note: string;
  created_at: string;
  updated_at: string;
}

export interface CommunicationResponse {
  success: boolean;
  data?: Communication;
  message?: string;
  error?: string;
}

export interface RecentCallsResponse {
  success: boolean;
  recentCalls?: RecentCall[];
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private apiUrl = `${environment.apiUrl}/dispo/communications`;

  constructor(private http: HttpClient) { }

  /**
   * Hole die letzten 3 Anrufnummern mit aktiven Anrufen zuerst
   */
  getRecentCalls(): Observable<RecentCallsResponse> {
    return this.http.get<RecentCallsResponse>(`${this.apiUrl}/recent-calls`);
  }

  /**
   * Speichere einen eingehenden Anruf
   */
  storeIncomingCall(callData: {
    callId: string;
    caller: string;
    callee?: string;
    callerInfo: {
      customerName?: string;
      orderId?: number;
      orderNumber?: string;
      personId?: number;
      rootOrderId?: number;
      orderData?: any;
      rootOrderData?: any;
    };
  }): Observable<CommunicationResponse> {
    return this.http.post<CommunicationResponse>(`${this.apiUrl}/incoming-call`, callData);
  }

  /**
   * Aktualisiere den Status eines Anrufs
   */
  updateCallStatus(callId: string, status: string, note?: string): Observable<CommunicationResponse> {
    return this.http.put<CommunicationResponse>(`${this.apiUrl}/${callId}/status`, {
      status,
      note
    });
  }

  /**
   * Hole alle Communications mit Pagination
   */
  getCommunications(limit: number = 50, offset: number = 0): Observable<{
    success: boolean;
    data: Communication[];
    total: number;
    limit: number;
    offset: number;
  }> {
    return this.http.get<any>(`${this.apiUrl}?limit=${limit}&offset=${offset}`);
  }

  /**
   * Hole spezifische Communication anhand der Call-ID
   */
  getCommunicationByCallId(callId: string): Observable<CommunicationResponse> {
    return this.http.get<CommunicationResponse>(`${this.apiUrl}/${callId}`);
  }

  /**
   * Hole Communications für eine bestimmte Order
   */
  getCommunicationsForOrder(orderId: number): Observable<{
    success: boolean;
    data: Communication[];
  }> {
    return this.http.get<any>(`${this.apiUrl}/order/${orderId}`);
  }

  /**
   * Hole Communications für eine bestimmte Person
   */
  getCommunicationsForPerson(personId: number): Observable<{
    success: boolean;
    data: Communication[];
  }> {
    return this.http.get<any>(`${this.apiUrl}/person/${personId}`);
  }
}
